import { MaxSizeValidator } from '@angular-material-components/file-input';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { TipoDTO } from 'app/main/apps/shared/interfaces/tipo.interface';

@Component({
  selector: 'app-dialog-documentos',
  templateUrl: './dialog-documentos.component.html',
  styleUrls: ['./dialog-documentos.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,

})
export class DialogDocumentosComponent implements OnInit {
  
  formulario: FormGroup;
  file: File;
  maxSize = 2;

  constructor(
    public dialogRef: MatDialogRef<DialogDocumentosComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private fb: FormBuilder) {
    //console.log(this.data);
  }


  ngOnInit(): void {
    this.initFormFactura();
  }


  initFormFactura() {
    this.formulario = this.fb.group({
        tipo: [null,{ validators: [Validators.required] },],
        fecha: [null, { validators: [Validators.required] }],
        documento: [
          this.file,
          [Validators.required, MaxSizeValidator(this.maxSize * 1024 * 1024)],
      ],
    });
  }

  get tipo() {
    return this.formulario.get("tipo");
  }

  get fecha() {
    return this.formulario.get("fecha");
  }

  get documento() {
    return this.formulario.get("documento");
  }

  getFile(event) {
    this.file = event && event.item(0);
  }

  guardar() {
    const data = {
        tipo: this.formulario.get('tipo').value,
        fecha: this.formulario.get('fecha').value,
        documento: this.file instanceof File ? this.file : null,
    };

    this.dialogRef.close(data);
  }
}
